import { Environment } from '../types/environment.interface';
import { provideDefaultKeycloak } from '@ps-gui/shared-core';

export const environment: Environment = {
  provideKeycloak: provideDefaultKeycloak,
};
